import React, {
  useRef,
  useState,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import { Line, PivotControls, Center } from "@react-three/drei";
import { connect } from "react-redux";
import action from "../../../../store/action";

import * as THREE from "three";

import store from "../../../../store";

import {
  getGumData,
  getToothData,
  getIPRData,
  getIPRToothOneIndex,
  getIPRToothTwoIndex,
  getIPRCenterPosition,
  getIprValue,
  getIPRVertices,
} from "../../../../dataInterface/index";

import { cloneDeep } from "lodash";
import IPR from "../../../../Components/CreateModal/IPR";
import CollisionArea from "../../../../Components/CreateModal/CollisionArea";
import { useFrame } from "@react-three/fiber";
import CollisionAreaModel from "../../../../Components/CreateModal/CollisionAreaModel";
import toothManager from "../../../../data/manager/toothManager";
import { TOOTH_GUM_TYPE } from "../../../../data/constant/toothConstant";
import IPRModel from "../../../../Components/CreateModal/IPRModel";
import { checkIPRVisible } from "../../../../data/util/iprUtil";
import { useThree } from "@react-three/fiber";
import IPRWithCollisionModel from "../../../../Components/CreateModal/IPRwithCollisonModel";
import stageManager from "../../../../data/manager/stageManager";
import { isSWM } from "../../../../config/env";

function IPRDataPro(props) {
  const {
    keyframeNumber,
    IPRCheckboxValue,
    collisionCheckboxValue,
    sliderVal,
  } = props;

  const stageNumber = keyframeNumber + 1;

  const iprModelList = useMemo(() => {
    return toothManager.getIPRModelList();
  }, []);

  return (
    <>
      {iprModelList.map((iprModel, index) => {
        const { toothGumType } = iprModel;

        const { activeStageNumber } =
          stageManager.getStageDOByStageNumberAndToothGumType(
            stageNumber,
            toothGumType,
          );

        const visible =
          iprModel.stageNumber === stageNumber ||
          iprModel.stageNumber === activeStageNumber;

        let collisionModelVisible = collisionCheckboxValue && visible;
        let iprModelVisible = IPRCheckboxValue && visible;

        if (isSWM()) {
          const isLastStage = stageManager.validLastStage(stageNumber);
          iprModelVisible = iprModelVisible && isLastStage;
        }

        return (
          <IPRWithCollisionModel
            iprModel={iprModel}
            iprModelVisible={iprModelVisible}
            collisionModelVisible={collisionModelVisible}
            sliderVal={sliderVal}
          />
        );
      })}
    </>
  );
}

const mapStateToProps = (state) => ({
  sliderVal: state.webViewer.sliderVal,
  IPRCheckboxValue: state.webViewer.IPRCheckboxValue,
  gridCheckboxValue: state.webViewer.gridCheckboxValue,
  collisionCheckboxValue: state.webViewer.collisionCheckboxValue,
  keyframeNumber: state.webViewer.keyframeNumber,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(IPRDataPro);
